import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/components/page-header'
import { ErrorState } from '@/components/empty-state'
import { Skeleton } from '@/components/ui/skeleton'
import { useSettings } from '@/features/admin/institution/api'
import { SettingsForm } from '@/features/admin/institution/settings-form'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/admin/institution')({
  beforeLoad: requirePermission('settings:manage'),
  component: InstitutionPage,
})

function InstitutionPage() {
  const { data, isLoading, error, refetch } = useSettings()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Administración"
        title="Institución"
        description="Datos legales, impuestos, riesgo, marca, módulos y permisos de su institución."
      />
      {isLoading ? (
        <Skeleton className="h-96 rounded-xl" />
      ) : error || !data ? (
        <div className="rounded-xl border border-border bg-card">
          <ErrorState error={error} onRetry={() => void refetch()} />
        </div>
      ) : (
        <SettingsForm settings={data.settings} />
      )}
    </div>
  )
}
